import { render, staticRenderFns } from "./OrderSidebar.vue?vue&type=template&id=234d45f7&"
import script from "./OrderSidebar.vue?vue&type=script&lang=js&"
export * from "./OrderSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports